import { bool } from 'prop-types'
import { useEffect } from 'react'

import { withI18n } from 'shared/utils/withI18n'
import expander from 'views/assets/scripts/expander'
import Notification from 'views/components/molecules/Notification'
import Collapsible from 'views/components/organisms/Collapsible'
import {
  POSITION_FIRST,
  POSITION_LAST,
} from 'views/components/organisms/Collapsible/consts'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import { i18nType } from 'views/utils/propTypes'

const PrescriptionFollowsModalContent = ({
  i18n,
  withNoPrescriptionFollows,
  expanded,
}) => {
  useEffect(() => {
    expander()
  }, [])

  return (
    <div id="prescriptionFollows-on-cart" className="u-padding--bottom">
      <Collapsible
        id="prescritonFollowsWithPrinter"
        label={i18n._(
          'cart.prescriptionFollows.descriptionToPrintWithPrinterHeadline'
        )}
        position={POSITION_FIRST}
        allScreensizes
        light
        expanded={expanded || withNoPrescriptionFollows}
        forceDisplayWhenCollapsed
      >
        <p className="u-padding-x-small--bottom">
          <TransWithHtml
            text={i18n._('cart.prescriptionFollows.freeEnvelope')}
          />
        </p>
        {withNoPrescriptionFollows && (
          <div className="u-margin--bottom">
            <Notification
              label={i18n._('prescriptionFollows.content.legal.text')}
            />
          </div>
        )}
      </Collapsible>
      <Collapsible
        id="prescritonFollowsWithoutPrinter"
        label={i18n._(
          'cart.prescriptionFollows.descriptionToPrintWithoutPrinterHeadline'
        )}
        position={POSITION_LAST}
        allScreensizes
        light
        expanded={expanded}
        forceDisplayWhenCollapsed
      >
        <div className="u-padding-x-small--bottom">
          <TransWithHtml
            text={i18n._('cart.prescriptionFollows.printFreeEnvelope')}
          />
        </div>
        {withNoPrescriptionFollows && (
          <div className="u-margin--bottom">
            <Notification
              label={i18n._('prescriptionFollows.content.legal.text')}
            />
          </div>
        )}
      </Collapsible>
    </div>
  )
}

PrescriptionFollowsModalContent.propTypes = {
  i18n: i18nType.isRequired,
  withNoPrescriptionFollows: bool,
  expanded: bool,
}

PrescriptionFollowsModalContent.defaultProps = {
  withNoPrescriptionFollows: false,
  expanded: false,
}

export default withI18n()(PrescriptionFollowsModalContent)
